import { HStack, VStack, Text, Image, Box, Tag } from '@chakra-ui/react';
import React from 'react';
import { formatPrice } from '../utils/helpers';

function OrderItemsList({ orderItems }) {
  return (
    <VStack alignItems='flex-start' spacing='4'>
      {orderItems.map((item, index) => {
        const { name, price, quantity, image, color, size, variantSelections } = item;
        const hasVariants = variantSelections && Object.keys(variantSelections).length > 0;
        return (
          <HStack key={index} alignItems='flex-start' spacing='5'>
            <Image
              src={image}
              boxSize='100px'
              objectFit='cover'
              borderRadius='lg'
            />
            <VStack alignItems='flex-start'>
              <HStack spacing='3' flexWrap='wrap'>
                <Text as='b'>{name}</Text>
                {hasVariants ? (
                  Object.entries(variantSelections).map(([vName, vVal]) => {
                    const isColor = typeof vVal === 'object' && vVal !== null && vVal.hex;
                    const displayVal = typeof vVal === 'object' && vVal !== null ? vVal.name : vVal;
                    return (
                      <Tag
                        key={vName}
                        variant='outline'
                        colorScheme='gray'
                        size='sm'
                      >
                        {isColor && (
                          <Box
                            bg={vVal.hex}
                            w='12px'
                            h='12px'
                            borderRadius='full'
                            mr='1'
                            border='1px solid'
                            borderColor='gray.300'
                          />
                        )}
                        {vName}: {displayVal}
                      </Tag>
                    );
                  })
                ) : (
                  <>
                    {color && <Box bg={color} p='2' borderRadius='5' />}
                    {size && (
                      <Tag
                        variant='outline'
                        colorScheme='brown'
                        size='sm'
                        textTransform='uppercase'
                      >
                        {size}
                      </Tag>
                    )}
                  </>
                )}
              </HStack>
              <Text color='green' fontWeight='bold'>{formatPrice(price)}</Text>
              <HStack spacing='2'>
                <Text as='b' color='gray.600'>Quantity:</Text>
                <Tag 
                  colorScheme='blue' 
                  size='lg' 
                  fontWeight='bold'
                  fontSize='md'
                >
                  {quantity}
                </Tag>
              </HStack>
            </VStack>
          </HStack>
        );
      })}
    </VStack>
  );
}

export default OrderItemsList;
